export default __webpack_public_path__ + "static/schedule-0a7f6a55b72eb5587796fcc4913e36ae.png";